<template>
	<v-container
		:data-test="`${dataTest}--loading-card`"
		class="d-flex flex-column justify-center align-center fill-height"
	>
		<v-progress-circular
			class="ma-5"
			:indeterminate="typeof progress === 'undefined'"
			:model-value="progress"
			align-self-center
			:size="size"
			:width="width"
			color="primary"
		>
			{{ typeof progress !== 'undefined' ? progress + '%' : '' }}
		</v-progress-circular>
		<slot v-if="text || $slots.default">
			<span v-if="text">{{ translate(text) }}</span>
		</slot>
	</v-container>
</template>

<script setup lang="ts">
import { useTranslate } from 'composables/useTranslate'

defineProps({
	flat: {
		type: Boolean,
		default: true,
	},
	size: {
		type: Number,
		default: 70,
	},
	width: {
		type: Number,
		default: 7,
	},
	progress: {
		type: Number,
		required: false,
		default: undefined,
	},
	text: {
		type: String,
		required: false,
		default: undefined,
	},
	dataTest: {
		type: String,
		required: false,
		default: '',
	},
})
const { translate } = useTranslate()
</script>

<style scoped></style>
